import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type { PageContextPayload } from '@sections/Admin/packs/Projects/screens/Detail/screens/Overview'

import type { TaskListModel } from '@models/types'

import useTrackingLink from '@hooks/useTrackingLink'
import useTrackingLinks from '@hooks/useTrackingLinks'

import TrackingLinkListItem from '@components/TrackingLinkListItem'

interface LinksProps {
  taskList: TaskListModel,
}

const Links = (props: LinksProps) => {
  const { taskList } = props

  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteTrackingLink,
    },
  } = pageContext

  const trackingLinksPayload = useTrackingLinks({
    filters: {
      recipient_type: 'TaskList',
      recipient_id: taskList.id,
    },
    performHttpRequests: !!taskList.id,
  })

  const { filteredTrackingLinks, hasFilteredTrackingLinks, loading } = trackingLinksPayload

  const trackingLinkPayload = useTrackingLink({
    owner_id: taskList.owner_id,
    owner_type: taskList.owner_type,
    subject_id: taskList.id,
    subject_type: 'TaskList',
    recipient_id: taskList.id,
    recipient_type: 'TaskList',
  })

  const { callbacks: { createOrEditTrackingLink } } = trackingLinkPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Project Links">
      <Box flexDirection="column">
        {filteredTrackingLinks.map(trackingLink => (
          <TrackingLinkListItem callbacks={{ deleteTrackingLink }} key={trackingLink.id} trackingLink={trackingLink} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredTrackingLinks ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditTrackingLink()}
          marginLeft="auto"
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Project Link
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Links
